/**
 * ./exercise4/Exercise4Summary.js
 * 
 * This module is similar with previous exercises. 
 * 
 */

import React, { useEffect, useState } from 'react';
import '../exercise1/Exercise1Summary.css';
import { useNavigate, useLocation } from 'react-router-dom';
import confettiSvg from '../components/icons/Confetti.svg';
import homeIcon from '../components/icons/Home.svg';
import { getFirestore, doc, getDoc } from 'firebase/firestore';

const Exercise4Summary = () => {
  const [showConfetti, setShowConfetti] = useState(true);
  const [workoutData, setWorkoutData] = useState(null);
  const [userId, setUserId] = useState(null);
  const location = useLocation();
  const currentTime = location.state?.currentTime || 0;
  const navigate = useNavigate();
  const duration = location.state.duration || 5; // Get duration from navigation state


  useEffect(() => {
    const timer = setTimeout(() => {
      setShowConfetti(false);
    }, 4000);
    return () => clearTimeout(timer);
  }, []);

  

  const handleNextSection = () => {
    navigate('/exercise4intro');
  };

  return (
    <div className="exercise-summary-container">
      {showConfetti && (
        <div className="confetti-container">
          <img
            src={confettiSvg}
            alt="Confetti"
            className="confetti-animation"
          />
        </div>
      )}

      <h1>Congratulations on completing the {duration} minute duration!</h1>
      <p>
        The rhythmic breathing you experienced will be used throughout the next
        few exercises. If you want a refresher on how to rhythmically breathe,
        you may come back to this exercise whenever you please.
      </p>

      <div className="improvement-section">
        <div className="improvement-text">
          <p>
            <strong>Click "Next" to move on to the next duration.</strong>
          </p>
          <p>Hint: Do this exercise for longer to increase focus time.</p>
        </div>
      </div>

      <div className="bottom-buttons">
        <button className="home-button" onClick={() => navigate("/")}>
          <img src={homeIcon} alt="Home" className="home-icon" />
        </button>
        <button className="next-button" onClick={handleNextSection}>
          Next
        </button>
      </div>
    </div>
  );
};

export default Exercise4Summary;
